import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconFacebookOutlined(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="Facebook">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22.3376 10.2989C21.4845 11.0779 21 12.3003 21 14.154V19H17V23H21V39H25V23H30.6002L30.9175 19H25V15.778C25 14.8698 25.346 14.1077 26.0187 13.6083C26.6422 13.1454 27.4241 13 28.152 13H31V9H26.922C24.6489 9 23.2091 9.5031 22.3376 10.2989ZM20.9889 8.82205C22.3799 7.5519 24.4011 7 26.922 7H33V15H28.152C27.6499 15 27.3558 15.1066 27.2108 15.2142C27.115 15.2853 27 15.4122 27 15.778V17H33.0825L32.4478 25H27V41H19V25H15V17H19V14.154C19 11.9637 19.5795 10.1091 20.9889 8.82205Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M40 2H8C4.68629 2 2 4.68629 2 8V40C2 43.3137 4.68629 46 8 46H40C43.3137 46 46 43.3137 46 40V8C46 4.68629 43.3137 2 40 2ZM8 0C3.58172 0 0 3.58172 0 8V40C0 44.4183 3.58172 48 8 48H40C44.4183 48 48 44.4183 48 40V8C48 3.58172 44.4183 0 40 0H8Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconFacebookOutline24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="Facebook">
            <path
                d="M16 7H14.076C13.461 7 13 7.252 13 7.889V9H16L15.762 12H13V20H10V12H8V9H10V7.077C10 5.055 11.064 4 13.461 4H16V7Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4 2C2.89543 2 2 2.89543 2 4V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20V4C22 2.89543 21.1046 2 20 2H4ZM0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconFacebook48(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="Facebook">
            <path
                d="M32 14H28.152C26.922 14 26 14.504 26 15.778V18H32L31.524 24H26V40H20V24H16V18H20V14.154C20 10.11 22.128 8 26.922 8H32V14Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M40 2H8C4.68629 2 2 4.68629 2 8V40C2 43.3137 4.68629 46 8 46H40C43.3137 46 46 43.3137 46 40V8C46 4.68629 43.3137 2 40 2ZM8 0C3.58172 0 0 3.58172 0 8V40C0 44.4183 3.58172 48 8 48H40C44.4183 48 48 44.4183 48 40V8C48 3.58172 44.4183 0 40 0H8Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconFacebookInverted(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="Facebook">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 0C3.58172 0 0 3.58172 0 8V40C0 44.4183 3.58172 48 8 48H40C44.4183 48 48 44.4183 48 40V8C48 3.58172 44.4183 0 40 0H8ZM28.152 14H32V8H26.922C22.128 8 20 10.11 20 14.154V18H16V24H20V40H26V24H31.524L32 18H26V15.778C26 14.504 26.922 14 28.152 14Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconFacebook24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="Facebook">
            <path
                d="M16 7H14.076C13.461 7 13 7.252 13 7.889V9H16L15.762 12H13V20H10V12H8V9H10V7.077C10 5.055 11.064 4 13.461 4H16V7Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4 2C2.89543 2 2 2.89543 2 4V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20V4C22 2.89543 21.1046 2 20 2H4ZM0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconFacebookSolid48(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="Facebook">
            <path
                d="M32 14H28.152C26.922 14 26 14.504 26 15.778V18H32L31.524 24H26V40H20V24H16V18H20V14.154C20 10.11 22.128 8 26.922 8H32V14Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
